import * as Yup from "yup";

export const eventSchema = Yup.object().shape({
  eventName: Yup.string().required("Event name is required"),
  eventDescription: Yup.string(),
  startDate: Yup.date()
    .required("Start date is required")
    .nullable()
    .test("valid-date", "Start date must be a valid date", function(value) {
      if (!value) return false;
      return !isNaN(value.getTime());
    }),
  startTime: Yup.date()
    .required("Start time is required")
    .nullable()
    .test("valid-time", "Start time must be a valid time", function(value) {
      if (!value) return false;
      return !isNaN(value.getTime());
    }),
  endDate: Yup.date()
    .required("End date is required")
    .nullable()
    .test("valid-date", "End date must be a valid date", function(value) {
      if (!value) return false;
      return !isNaN(value.getTime());
    }),
  endTime: Yup.date()
    .required("End time is required")
    .nullable()
    .test("valid-time", "End time must be a valid time", function(value) {
      if (!value) return false;
      return !isNaN(value.getTime());
    })
    .test(
      "end-after-start",
      "End date & time must be after start date & time",
      function (endTime) {
        const { startDate, startTime: startTimeValue, endDate } = this.parent;
        if (!startDate || !startTimeValue || !endDate || !endTime) return true;
        
        // Combine start date + time
        const startDateTime = new Date(startDate);
        startDateTime.setHours(startTimeValue.getHours());
        startDateTime.setMinutes(startTimeValue.getMinutes());
        startDateTime.setSeconds(startTimeValue.getSeconds());
        
        // Combine end date + time
        const endDateTime = new Date(endDate);
        endDateTime.setHours(endTime.getHours());
        endDateTime.setMinutes(endTime.getMinutes());
        endDateTime.setSeconds(endTime.getSeconds());
        
        return endDateTime.getTime() > startDateTime.getTime();
      }
    ),
});
